export default __webpack_public_path__ + "static/media/edit-icon.f12b4dcb.svg";